import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Components as InputComponents } from './input.style';
import { Components as FormComponents } from '../../styles/FormElements';
import Label from '../Label';
import ErrorMessage from '../ErrorMessage';
import Hint from '../Hint';
const Input = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className = 'input',
      onChange,
      focus,
      label,
      required,
      icon,
      iconPosition = 'left',
      prefix,
      suffix,
      clearButton,
      onClear,
      error,
      hint,
      value,
      width,
      loading,
      fit = 'medium',
      variant = 'default',
      onClick,
      onIconClick,
      disabled = false,
      readOnly = false,
      onFocus,
      onBlur,
      select = false,
      autocomplete = 'off'
    } = props,
    rest = __rest(props, ["className", "onChange", "focus", "label", "required", "icon", "iconPosition", "prefix", "suffix", "clearButton", "onClear", "error", "hint", "value", "width", "loading", "fit", "variant", "onClick", "onIconClick", "disabled", "readOnly", "onFocus", "onBlur", "select", "autocomplete"]);
  return _jsxs(FormComponents.Wrapper, _extends({
    width: width,
    className: "wrapper-".concat(className, " ").concat(className)
  }, {
    children: [label && _jsx(Label, _extends({
      label: label,
      required: required,
      fit: fit,
      className: className
    }, rest)), _jsxs(InputComponents.Area, {
      children: [_jsx(InputComponents.Input, _extends({
        className: className,
        ref: ref,
        autoFocus: focus,
        onChange: onChange,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        icon: icon,
        clearButton: clearButton,
        error: error,
        iconPosition: iconPosition,
        prefix: prefix === null || prefix === void 0 ? void 0 : prefix.slice(0, 3),
        suffix: suffix === null || suffix === void 0 ? void 0 : suffix.slice(0, 3),
        value: value,
        fit: fit,
        variant: variant,
        disabled: disabled,
        readOnly: readOnly,
        select: select,
        autocomplete: autocomplete,
        "aria-required": required
      }, rest)), prefix && _jsx(InputComponents.Prefix, _extends({
        fit: fit
      }, {
        children: prefix === null || prefix === void 0 ? void 0 : prefix.slice(0, 3)
      })), icon && iconPosition === 'left' && !prefix && _jsx(FormComponents.InputIcon, {
        iconPosition: iconPosition,
        fit: fit,
        name: icon,
        onClick: onIconClick,
        disabled: disabled || readOnly
      }), loading && _jsx(InputComponents.LoadingIndicator, _extends({
        fit: fit
      }, {
        children: _jsxs("svg", _extends({
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 100 100"
        }, {
          children: [_jsx("circle", {
            className: "track",
            cx: "50",
            cy: "50",
            fill: "none",
            r: "40"
          }), _jsx("circle", {
            className: "spinner",
            cx: "50",
            cy: "50",
            fill: "none",
            r: "40",
            strokeDasharray: "55 200"
          })]
        }))
      })), suffix && !loading && _jsx(InputComponents.Suffix, _extends({
        fit: fit
      }, {
        children: suffix === null || suffix === void 0 ? void 0 : suffix.slice(0, 3)
      })), !suffix && !loading && icon && iconPosition === 'right' && _jsx(FormComponents.InputIcon, {
        iconPosition: iconPosition,
        fit: fit,
        name: icon,
        onClick: onIconClick,
        disabled: disabled || readOnly
      }), clearButton && value && !loading &&
      //removed icon and added plain button with focus variant
      _jsx(InputComponents.ClearIconButtons, {
        icon: "times-circle",
        onClick: onClear,
        fit: fit,
        variant: "plain",
        disabled: disabled || readOnly,
        ariacurrent: "false",
        issuffix: !!suffix || iconPosition === 'right'
      })]
    }), error && _jsx(ErrorMessage, _extends({
      fit: fit
    }, rest)), hint && _jsx(Hint, _extends({
      hint: hint,
      fit: fit
    }, rest))]
  }));
});
export default Input;